<template>
  <div>
    <BlankPage title="Pharmacies" :breadcrumbs="[{name:'Services', path:'#'}, {name:'Pharmacies', path:'/pharmacies'}]">

      <div class="row">

        <div class="col-md-3">
          <aside class="widget widget-search">
            <form class="search-form" action="#" method="post">
              <input type="search" name="s" placeholder="Rechecher..." />
              <button type="submit"><i class="fal fa-search"></i></button>
            </form>
          </aside>
          <!--<div class="checkbox-wrapper-10">
            <input checked="" type="checkbox" @click="allOrOnCall" id="cb5" class="tgl tgl-flip" style="display: none">
            <label for="cb5" data-tg-on="Toutes" data-tg-off="Gardes" class="tgl-btn"></label>
          </div>-->
        </div>
        <!--<div class="col-md-3">
          <select v-model="activeOnCall" @change="allOrOnCall" class="form-select garde-select">
            <option :value="false">Toutes</option>
            <option :value="true">Gardes</option>
          </select>
        </div>-->
        <div class="col">
          <CustomPagination :items="this.onCalls" @changePage="onChangePage" :labels="customLabels" :pageSize="6"></CustomPagination>
        </div>

      </div>

      <!--====== APPIE SERRVICE 2 PART START ======-->
      <div class="box-container">
        <PharmaciesCard v-for="pharmacy in pageOfItems" :key="pharmacy.id" :pharmacy="pharmacy" :is-on-call="isOnCall(pharmacy.id)"/>
      </div>
      <!--====== APPIE SERRVICE 2 PART ENDS ======-->
    </BlankPage>
  </div>
</template>

<script>
import BlankPage from "@/components/BlankPage/index.vue";
import PharmaciesCard from "@/components/Cards/pharmaciesCard.vue";
// import { onCalls, /*dataPharmacies*/} from "@/views/Servcies/pharmaciesData";
import CustomPagination from "@/components/custom-pagination.vue";
// import {onCallService} from "@/services/oncall.service";
import {pharmacyService} from "@/services/pharmacy.service";
import {onCallService} from "@/services/oncall.service";
// import ServicesHomeTwo from "@/components/HomeTwo/ServicesHomeTwo.vue";

export default {
  components: {
    CustomPagination,
    PharmaciesCard,
    // ServicesHomeTwo,
    BlankPage
  },
  data() {
    return {
      customLabels: {
        first: 'Premier',
        last: 'Dernier',
        previous: 'Précédant',
        next: 'Suivant'
      },
      activeOnCall: true,
      onCalls: [],
      allPharmacies: [],
      pageOfItems: []
    }
  },
  methods: {
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems
    },
    isOnCall(id) {
      return this.onCalls.some(onCall => onCall.id === id)
    },
    allOrOnCall() {
      this.pageOfItems = this.pharmacies;
      this.onChangePage(this.pharmacies.slice(0, 6));
    },
    async getPharmacies() {
      this.onCalls = (await onCallService.get())[0].pharmacies;
      this.allPharmacies = await pharmacyService.get();
      // this.pageOfItems = this.onCalls.slice(0, 6);
    }
  },
  computed: {
    pharmacies() {
      return this.activeOnCall ? this.onCalls : this.allPharmacies
    }
  },
  created() {
    this.getPharmacies()
  },
  mounted() {
    this.getPharmacies();
  }
}
</script>

<style>
.garde-select {
  width: 100%;
  height: 50px;
  font-size: 14px;
  line-height: 50px;
  border-radius: 3px;
  font-weight: 500;
  border: none;
  background: #f1f0f5;
  color: #8f8d98;
  outline: none;
  padding: 0 25px;
}
.box-container {
  flex-wrap: wrap;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 35px 15px;
  width: 100%;
}

.group-search {
  display: flex;
  line-height: 28px;
  align-items: center;
  position: relative;
  max-width: 300px;
}

.input-search {
  width: 100%;
  height: 40px;
  line-height: 28px;
  padding: 0 1rem;
  padding-left: 2.5rem;
  border: 2px solid transparent;
  border-radius: 8px;
  outline: none;
  background-color: #f3f3f4;
  color: #0d0c22;
  transition: .3s ease;
}

.input-search::placeholder {
  color: #9e9ea7;
}

.input-search:focus, input:hover {
  outline: none;
  border-color: rgba(234,76,137,0.4);
  background-color: #fff;
  box-shadow: 0 0 0 4px rgb(234 76 137 / 10%);
}

.icon-search {
  position: absolute;
  left: 1rem;
  fill: #9e9ea7;
  width: 1rem;
  height: 1rem;
}

@media screen and (min-width:1380px) {
  .box-container {
    flex-wrap: wrap;
    flex-direction: row
  }
}

// Switcher
.checkbox-wrapper-10 .tgl {
  display: none;
}

.checkbox-wrapper-10 .tgl,
.checkbox-wrapper-10 .tgl:after,
.checkbox-wrapper-10 .tgl:before,
.checkbox-wrapper-10 .tgl *,
.checkbox-wrapper-10 .tgl *:after,
.checkbox-wrapper-10 .tgl *:before,
.checkbox-wrapper-10 .tgl + .tgl-btn {
  box-sizing: border-box;
}

.checkbox-wrapper-10 .tgl::-moz-selection,
.checkbox-wrapper-10 .tgl:after::-moz-selection,
.checkbox-wrapper-10 .tgl:before::-moz-selection,
.checkbox-wrapper-10 .tgl *::-moz-selection,
.checkbox-wrapper-10 .tgl *:after::-moz-selection,
.checkbox-wrapper-10 .tgl *:before::-moz-selection,
.checkbox-wrapper-10 .tgl + .tgl-btn::-moz-selection,
.checkbox-wrapper-10 .tgl::selection,
.checkbox-wrapper-10 .tgl:after::selection,
.checkbox-wrapper-10 .tgl:before::selection,
.checkbox-wrapper-10 .tgl *::selection,
.checkbox-wrapper-10 .tgl *:after::selection,
.checkbox-wrapper-10 .tgl *:before::selection,
.checkbox-wrapper-10 .tgl + .tgl-btn::selection {
  background: none;
}

.checkbox-wrapper-10 .tgl + .tgl-btn {
  outline: 0;
  display: block;
  width: 4em;
  height: 2em;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox-wrapper-10 .tgl + .tgl-btn:after,
.checkbox-wrapper-10 .tgl + .tgl-btn:before {
  position: relative;
  display: block;
  content: "";
  width: 50%;
  height: 100%;
}

.checkbox-wrapper-10 .tgl + .tgl-btn:after {
  left: 0;
}

.checkbox-wrapper-10 .tgl + .tgl-btn:before {
  display: none;
}

.checkbox-wrapper-10 .tgl:checked + .tgl-btn:after {
  left: 50%;
}

.checkbox-wrapper-10 .tgl-flip + .tgl-btn {
  padding: 2px;
  transition: all 0.2s ease;
  font-family: sans-serif;
  perspective: 100px;
}

.checkbox-wrapper-10 .tgl-flip + .tgl-btn:after,
.checkbox-wrapper-10 .tgl-flip + .tgl-btn:before {
  display: inline-block;
  transition: all 0.4s ease;
  width: 100%;
  text-align: center;
  position: absolute;
  line-height: 2em;
  font-weight: bold;
  color: #fff;
  top: 0;
  left: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 4px;
}

.checkbox-wrapper-10 .tgl-flip + .tgl-btn:after {
  content: attr(data-tg-on);
  background: #7802c6;
  transform: rotateY(-180deg);
}

.checkbox-wrapper-10 .tgl-flip + .tgl-btn:before {
  background: #197dff;
  content: attr(data-tg-off);
}

.checkbox-wrapper-10 .tgl-flip + .tgl-btn:active:before {
  transform: rotateY(-20deg);
}

.checkbox-wrapper-10 .tgl-flip:checked + .tgl-btn:before {
  transform: rotateY(180deg);
}

.checkbox-wrapper-10 .tgl-flip:checked + .tgl-btn:after {
  transform: rotateY(0);
  left: 0;
  background: #7e09eb;
}

.checkbox-wrapper-10 .tgl-flip:checked + .tgl-btn:active:after {
  transform: rotateY(20deg);
}


</style>
